import { TooltipProvider } from "@radix-ui/react-tooltip";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./components/ui/theme-provider.jsx";
import { UserProvider } from "./context/user-context.jsx";
import "./index.css";
import router from "./routes/router.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <UserProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </UserProvider>
    </ThemeProvider>
  </StrictMode>,
);
